import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type { UnusedSkipTokenOptions } from '@tanstack/react-query'
import type { HttpErrorResponse } from '@/types/error'
import type { HTTPError } from 'ky'
import type { Except } from 'type-fest'
import { notificationService } from '@/services/notification'

export const getNotificationTabListQueryOptions = (
  options?: Except<
    UnusedSkipTokenOptions<
      Awaited<ReturnType<typeof notificationService.tabList>>,
      HTTPError<HttpErrorResponse>,
      Awaited<ReturnType<typeof notificationService.tabList>>,
      ReturnType<typeof queryKeys.notification.tabList>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.notification.tabList(),
    queryFn: ({ signal }) => notificationService.tabList({ signal }),
    ...options,
  })

export const getNotificationsQueryOptions = (
  params: Parameters<typeof notificationService.notifications>[0],
) =>
  infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: queryKeys.notification.notifications(params),
    queryFn: ({ signal, pageParam }) =>
      notificationService.notifications(
        { ...params, page: pageParam },
        { signal },
      ),
    getNextPageParam: (lastPage) => lastPage.meta.next_page,
  })
